import { Campus } from "./store/main/types";

export interface Pagination {
    path: string;
    current_page: number;
    last_page: number;
    base: string;
    next?: string;
    prev?: string;
    per_page: number;
    total: number;
}

export interface EventOrientation {
    id: string;
    record_type_name: string;
    address?: string;
    campus_name: string;
    date: string;
    time: string;
    location?: string;
    type: string;
    time_zone?: string;
    jobId?: string;
}

export interface GlobalEventsOrientations {
    orientations: EventOrientation[];
    pagination: Pagination;
    jobId?: string;
}

export interface EventsViewState {
    campusSelection: string;
    campusSelectionName?: string;
    dateSelection: string | null;
    campusData: Campus | null;
    campusRaw: Campus[];
    campusFocused: boolean;
}

export interface EventViewJoinState {
    showError404: boolean;
    campusData?: Campus[] | null;
    cancelUrl: string;
    selectedDate: EventOrientation | null;
    selectedCampus: Campus | null;
    eventsData: GlobalEventsOrientations | null;
}

export interface EventNoCampusNoDateJoinState {
    showError404: boolean;
    cancelUrl: string;
    eventsData: EventOrientation | null;
    loading: boolean;
}

export const getKeyValue =
    <U extends keyof T, T extends object>(key: U) =>
    (obj: T) =>
        obj[key];

export interface errorResponse {
    message: string;
    status: string;
    status_code: number;
}
